import { useTranslation } from 'react-i18next';

const useTranslate = () => {
	const { t } = useTranslation();

	const translate = (key: string, options?: Record<string, string>) => t(key, options);

	return { translate };
};

export default useTranslate;
